import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { endSession, hasUsableSession, sessionExpiresAt, SESSION_ENDED } from './session';

const SessionGuard: React.FC = () => {
  const [sessionEnded, setSessionEnded] = useState(false);
  const token = localStorage.getItem('token');
  const usable = hasUsableSession(token);

  useEffect(() => {
    const onSessionEnded = () => setSessionEnded(true);
    window.addEventListener(SESSION_ENDED, onSessionEnded);
    return () => window.removeEventListener(SESSION_ENDED, onSessionEnded);
  }, []);

  useEffect(() => {
    if (token && !usable) endSession(token);
  }, [token, usable]);

  useEffect(() => {
    const expiry = sessionExpiresAt(token);
    if (!token || expiry === null || !usable) return;
    let timer: ReturnType<typeof setTimeout>;
    const schedule = () => {
      const remaining = expiry - Date.now();
      if (remaining <= 0) endSession(token);
      else timer = setTimeout(schedule, Math.min(remaining, 2147483647));
    };
    schedule();
    return () => clearTimeout(timer);
  }, [token, usable]);

  if (!usable || sessionEnded) return <Navigate to="/admin" replace />;
  return <Outlet />;
};

export default SessionGuard;
